import clsx from 'clsx'
import { ComponentProps, forwardRef, useMemo } from 'react'
import Style from './style.module.scss'

interface IProps extends ComponentProps<'div'> {
  bg?: 'Orange/300' | 'neutral300' | 'neutral800' | 'turquoise550' | 'negative500' | 'negative800' | 'greeng500' | 'gradient'
  reverseBorder?: boolean
}

export const Flag = forwardRef(function (
  {
    bg,
    reverseBorder,
    ...props
  }: IProps,
  ref: ComponentProps<'div'>['ref']
) {
  const _bg = useMemo(() => {
    switch (bg) {
      case 'neutral300':
        return '#EFEFEF'
      case 'neutral800':
        return '#959595'
      case 'turquoise550':
        return '#78E59E'
      case 'negative500':
        return '#FBC3BC'
      case 'negative800':
        return '#F7564E'
      case 'greeng500':
        return '#C2F213'
      case 'Orange/300':
        return '#FFCF99'
      case 'gradient':
        return 'linear-gradient(90deg, #7EF2A7 0%, #9EF291 24.5%, #C2F213 59%, #CCF241 75%, #D4D94A 100%)'
    }
  }, [bg])
  const color = useMemo(() => {
    switch (bg) {
      case 'neutral800':
      case 'negative800':
        return '#FFFFFF'
      case 'neutral300':
      case 'turquoise550':
      case 'negative500':
      case 'greeng500':
      case 'Orange/300':
      case 'gradient':
        return '#0C0C0C'
    }
  }, [bg])

  return (
    <div
      {...props}
      ref={ref}
      className={clsx(Style.flag, { [Style.reverseBorder]: reverseBorder }, 'semibold-12', props.className)}
      style={{
        color,
        backgroundColor: _bg,
        ...props.style
      }}
    >
      {props.children}
    </div>
  )
})
